module.exports = __webpack_public_path__ + "img/locate.42918f07.svg";